import React, { Component } from "react";

const HygieneIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width='53'
      height='53'
      viewBox='0 0 53 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M52.8608 3.59378C44.2707 1.12504 35.3678 -0.0839757 26.4304 0.00452924C17.493 -0.0839757 8.59011 1.12504 0 3.59378L0 49.2823C8.59011 51.751 17.493 52.96 26.4304 52.8715C35.3678 52.96 44.2707 51.751 52.8608 49.2823V3.59378Z'
        fill='#E31C79'
      />
      <path
        d='M25.9291 30.149C24.9954 30.149 24.2527 30.8068 24.2527 31.7193C24.2527 32.6318 24.9954 33.332 25.9291 33.332C26.884 33.332 27.6055 32.6318 27.6055 31.7193C27.6055 30.8068 26.884 30.149 25.9291 30.149ZM27.2872 18.4354L24.5498 18.4354L24.5498 28.897L27.2872 28.3241L27.2872 18.4354Z'
        fill='white'
      />
      <circle
        cx='26'
        cy='26'
        r='14.0441'
        stroke='white'
        strokeWidth='3.91176'
      />
    </svg>
  );
};

HygieneIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "black",
};

export default HygieneIcon;
